module.exports = __webpack_public_path__ + "img/abertosInactive.91076c21.svg";